// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".skeleton__item[data-v-06b5be2f]{--inset:16px;margin:var(--inset);width:calc(100% - var(--inset)*2);height:calc(100% - var(--inset)*2)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
